import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";
import { Linking, ScrollView, Text, View } from "react-native";
import AccountItem from "@/elements/components/account/account-item";
import AccountItemDivider from "@/elements/components/account/account-item-divider";
import ResourcesEmptyState from "@/elements/components/account/resources-empty-state";
import Loader from "@/elements/components/shared/loader";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import { AppBar } from "@/elements/components/ui/app-bar";
import { api } from "@/elements/components/utils/convex-api";
import goBack from "@/elements/components/utils/go-back";

function openResource(url: string) {
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  void Linking.openURL(url);
}

function ResourcesScreen() {
  const { data: resources, isLoading } = useQuery(
    convexQuery(api.accountResources.queries.list, {}),
  );

  if (isLoading) {
    return <Loader />;
  }

  const hasResources = (resources?.length ?? 0) > 0;

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Back</AppBar.Title>
      </AppBar>

      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="mx-5">
            <View className="h-2" />
            <View className="gap-1">
              <Text className="font-zilla-slab-medium font-medium text-dark text-[28px] leading-[1.2]">
                Resources
              </Text>
              <Text className="font-geologica-regular font-normal text-base text-gray-800 leading-[1.5]">
                Guides and helpful documents
              </Text>
            </View>
          </View>

          <View className="h-8" />

          {!hasResources ? (
            <ResourcesEmptyState />
          ) : (
            resources?.map((resource) => (
              <Fragment key={resource.id}>
                <AccountItemDivider />
                <AccountItem
                  title={resource.title}
                  onPress={() => {
                    if (resource.url) openResource(resource.url);
                  }}
                />
              </Fragment>
            ))
          )}

          {hasResources && <AccountItemDivider />}

          <View className="h-8" />
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default ResourcesScreen;
